import DapDSDatePicker from './datepicker.component'

export * from './datepicker.component'
export default DapDSDatePicker

DapDSDatePicker.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-datepicker': DapDSDatePicker
  }
}
